import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Url } from 'src/url/url'

const IconPlus   = () => <span style={{ fontSize: 16 }}>＋</span>
const IconEdit   = () => <span style={{ fontSize: 13 }}>✏️</span>
const IconDelete = () => <span style={{ fontSize: 13 }}>🗑️</span>
const IconEye    = () => <span style={{ fontSize: 13 }}>👁️</span>
const IconEyeOff = () => <span style={{ fontSize: 13 }}>🙈</span>
const IconClose  = () => <span style={{ fontSize: 18 }}>✕</span>

const EMPTY_FORM = { name: '', email: '', password: '', roleId: '', roleName: '', slug: '' } // ✅ slug add


const AddManagementMember = () => {
  const [members, setMembers]             = useState([])
  const [roles, setRoles]                 = useState([])
  const [loading, setLoading]             = useState(true)
  const [saving, setSaving]               = useState(false)
  const [showModal, setShowModal]         = useState(false)
  const [editTarget, setEditTarget]       = useState(null)
  const [form, setForm]                   = useState(EMPTY_FORM)
  const [showPass, setShowPass]           = useState(false)
  const [toast, setToast]                 = useState(null)
  const [deleteConfirm, setDeleteConfirm] = useState(null)

  const showToast = (msg, type = 'success') => {
    setToast({ msg, type })
    setTimeout(() => setToast(null), 3000)
  }

  useEffect(() => { fetchAll() }, [])

  const fetchAll = async () => {
    setLoading(true)
    try {
      const membersRes = await axios.get(`${Url}/management-staff`)
      setMembers(membersRes.data?.data || [])
    } catch (err) { console.error('Members error:', err) }

    try {
      const rolesRes = await axios.get(`${Url}/role`)
      setRoles(rolesRes.data || [])
    } catch (err) { console.error('Roles error:', err) }

    setLoading(false)
  }

  const openAddModal = () => {
    setEditTarget(null)
    setForm(EMPTY_FORM)
    setShowPass(false)
    setShowModal(true)
  }

  const openEditModal = (member) => {
    setEditTarget(member)
    setForm({
      name:     member.name,
      email:    member.email,
      password: '',
      roleId:   member.roleId?._id || member.roleId,
      roleName: member.roleName,
      slug:     member.slug || '',  
    })
    setShowPass(false)
    setShowModal(true)
  }

  
  const closeModal = () => {
    setShowModal(false)
    setEditTarget(null)
    setForm(EMPTY_FORM)
  }

  const handleFormChange = (e) => {
    const { name, value } = e.target
    if (name === 'roleId') {
      const selectedRole = roles.find(r => r._id === value)
      setForm(prev => ({ ...prev, roleId: value, roleName: selectedRole?.role || '' }))
    } else {
      setForm(prev => ({ ...prev, [name]: value }))
    }
  }

  const handleSubmit = async () => {
    if (!form.name.trim() || !form.email.trim() || !form.roleId || !form.slug.trim()) {
      return showToast('Name, Email, Role aur Slug required hain!', 'error')
    }
    if (!editTarget && !form.password.trim()) {
      return showToast('Password required hai!', 'error')
    }
    setSaving(true)
    try {
      if (editTarget) {
        const payload = {
          name: form.name,
          email: form.email,
          roleId: form.roleId,
          roleName: form.roleName,
          slug: form.slug,  // ✅
        }
        if (form.password.trim()) payload.password = form.password
        const res = await axios.put(`${Url}/management-staff/${editTarget._id}`, payload)
        setMembers(prev => prev.map(m => m._id === editTarget._id ? res.data.data : m))
        showToast('Member update ho gaya! ✓')
      } else {
        const res = await axios.post(`${Url}/management-staff`, form)
        setMembers(prev => [res.data.data, ...prev])
        showToast('Member add ho gaya! ✓')
      }
      closeModal()
    } catch (err) {
      showToast(err.response?.data?.message || 'Error aaya!', 'error')
    } finally {
      setSaving(false)
    }
  }

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${Url}/management-staff/${id}`)
      setMembers(prev => prev.filter(m => m._id !== id))
      setDeleteConfirm(null)
      showToast('Member delete ho gaya!')
    } catch (err) { showToast('Delete mein error!', 'error') }
  }

  const handleToggleStatus = async (id) => {
    try {
      const res = await axios.patch(`${Url}/management-staff/toggle/${id}`)
      setMembers(prev => prev.map(m => m._id === id ? { ...m, isActive: res.data.data.isActive } : m))
      showToast(res.data.message)
    } catch (err) { showToast('Status change mein error!', 'error') }
  }

  const getInitials = (name) =>
    name?.split(' ').map(w => w[0]).slice(0, 2).join('').toUpperCase() || '?'

  const avatarColors = ['#1e40af', '#7c3aed', '#db2777', '#059669', '#d97706', '#dc2626', '#0891b2']
  const getColor = (name) => avatarColors[(name?.charCodeAt(0) || 0) % avatarColors.length]

  return (
    <div style={{ padding: 24, fontFamily: 'system-ui, sans-serif', background: '#f8fafc', minHeight: '100vh' }}>

      {/* Toast */}
      {toast && (
        <div style={{
          position: 'fixed', top: 20, right: 20, zIndex: 9999,
          padding: '12px 20px', borderRadius: 10, fontSize: 13, fontWeight: 600,
          background: toast.type === 'error' ? '#fef2f2' : '#f0fdf4',
          color: toast.type === 'error' ? '#dc2626' : '#16a34a',
          border: `1px solid ${toast.type === 'error' ? '#fecaca' : '#bbf7d0'}`,
          boxShadow: '0 4px 12px rgba(0,0,0,.12)',
        }}>
          {toast.type === 'error' ? '❌' : '✅'} {toast.msg}
        </div>
      )}

      {/* Delete Confirm */}
      {deleteConfirm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 9998, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ background: 'white', borderRadius: 14, padding: 28, width: 340, textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,.2)' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>🗑️</div>
            <h3 style={{ margin: '0 0 8px', fontSize: 16, color: '#1e293b' }}>Member Delete Karein?</h3>
            <p style={{ margin: '0 0 20px', fontSize: 13, color: '#64748b' }}>Yeh action undo nahi ho sakta!</p>
            <div style={{ display: 'flex', gap: 10, justifyContent: 'center' }}>
              <button onClick={() => setDeleteConfirm(null)}
                style={{ padding: '9px 22px', fontSize: 13, fontWeight: 600, background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, cursor: 'pointer' }}>
                Cancel
              </button>
              <button onClick={() => handleDelete(deleteConfirm)}
                style={{ padding: '9px 22px', fontSize: 13, fontWeight: 700, background: '#dc2626', color: 'white', border: 'none', borderRadius: 8, cursor: 'pointer' }}>
                Haan, Delete Karo
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal */}
      {showModal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 9997, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ background: 'white', borderRadius: 16, width: '100%', maxWidth: 480, boxShadow: '0 20px 60px rgba(0,0,0,.2)', overflow: 'hidden' }}>

            {/* Modal Header */}
            <div style={{ padding: '18px 24px', borderBottom: '1px solid #f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: editTarget ? '#eff6ff' : '#f0fdf4' }}>
              <h3 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#1e293b' }}>
                {editTarget ? '✏️ Member Edit Karein' : '➕ New Member Add'}
              </h3>
              <button onClick={closeModal}
                style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 20, color: '#94a3b8' }}>
                <IconClose />
              </button>
            </div>

            {/* Modal Body */}
            <div style={{ padding: 24, maxHeight: '70vh', overflowY: 'auto' }}>

              {/* Name */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 6 }}>Full Name *</label>
                <input name="name" value={form.name} onChange={handleFormChange}
                  placeholder="e.g. Rahul Sharma"
                  style={{ width: '100%', padding: '10px 12px', fontSize: 13, border: '1.5px solid #e2e8f0', borderRadius: 8, outline: 'none', boxSizing: 'border-box' }} />
              </div>

              {/* Email */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 6 }}>Email *</label>
                <input name="email" value={form.email} onChange={handleFormChange}
                  placeholder="e.g. rahul@gigbig.com" type="email"
                  style={{ width: '100%', padding: '10px 12px', fontSize: 13, border: '1.5px solid #e2e8f0', borderRadius: 8, outline: 'none', boxSizing: 'border-box' }} />
              </div>

              {/* Password */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 6 }}>
                  Password {editTarget ? '(khali chodo agar change nahi karna)' : '*'}
                </label>
                <div style={{ position: 'relative' }}>
                  <input name="password" value={form.password} onChange={handleFormChange}
                    placeholder={editTarget ? 'Naya password (optional)' : 'Min 6 characters'}
                    type={showPass ? 'text' : 'password'}
                    style={{ width: '100%', padding: '10px 40px 10px 12px', fontSize: 13, border: '1.5px solid #e2e8f0', borderRadius: 8, outline: 'none', boxSizing: 'border-box' }} />
                  <button onClick={() => setShowPass(!showPass)}
                    style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer' }}>
                    {showPass ? <IconEyeOff /> : <IconEye />}
                  </button>
                </div>
              </div>

              {/* Slug ✅ */}
              <div style={{ marginBottom: 16 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 6 }}>
                  Slug * <span style={{ fontSize: 11, color: '#94a3b8', fontWeight: 400 }}>(e.g. help-support, sales-manager)</span>
                </label>
                <input name="slug" value={form.slug} onChange={handleFormChange}
                  placeholder="e.g. help-support"
                  style={{ width: '100%', padding: '10px 12px', fontSize: 13, border: '1.5px solid #e2e8f0', borderRadius: 8, outline: 'none', boxSizing: 'border-box' }} />
              </div>

              {/* Role */}
              <div style={{ marginBottom: 24 }}>
                <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#475569', marginBottom: 6 }}>Role *</label>
                <select name="roleId" value={form.roleId} onChange={handleFormChange}
                  style={{ width: '100%', padding: '10px 12px', fontSize: 13, border: '1.5px solid #e2e8f0', borderRadius: 8, outline: 'none', background: 'white', boxSizing: 'border-box', cursor: 'pointer' }}>
                  <option value="">-- Role Select Karein --</option>
                  {roles.map(r => (
                    <option key={r._id} value={r._id}>{r.role}</option>
                  ))}
                </select>
              </div>

              {/* Buttons */}
              <div style={{ display: 'flex', gap: 10 }}>
                <button onClick={closeModal}
                  style={{ flex: 1, padding: '11px', fontSize: 13, fontWeight: 600, background: '#f1f5f9', color: '#475569', border: 'none', borderRadius: 8, cursor: 'pointer' }}>
                  Cancel
                </button>
                <button onClick={handleSubmit} disabled={saving}
                  style={{ flex: 2, padding: '11px', fontSize: 13, fontWeight: 700, background: saving ? '#94a3b8' : '#1e40af', color: 'white', border: 'none', borderRadius: 8, cursor: saving ? 'not-allowed' : 'pointer' }}>
                  {saving ? '⏳ Saving...' : editTarget ? '✏️ Update Karein' : '➕ Add Karein'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Page Header */}
      <div style={{ marginBottom: 24, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
        <div>
          <h2 style={{ margin: 0, fontSize: 22, fontWeight: 700, color: '#1e293b' }}>Management Staff</h2>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: '#64748b' }}>Add Management</p>
        </div>
        <button onClick={openAddModal}
          style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '10px 20px', fontSize: 13, fontWeight: 700, background: '#1e40af', color: 'white', border: 'none', borderRadius: 10, cursor: 'pointer', boxShadow: '0 2px 8px rgba(30,64,175,.3)' }}>
          <IconPlus /> Add New
        </button>
      </div>

      {/* Stats Cards */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 14, marginBottom: 24 }}>
        {[
          { label: 'Total Members', value: members.length,                          color: '#1e40af' },
          { label: 'Active',        value: members.filter(m => m.isActive).length,  color: '#16a34a' },
          { label: 'Inactive',      value: members.filter(m => !m.isActive).length, color: '#dc2626' },
          { label: 'Total Roles',   value: roles.length,                            color: '#92400e' },
        ].map(s => (
          <div key={s.label} style={{ background: 'white', borderRadius: 12, padding: '16px 20px', border: '1px solid #e2e8f0', boxShadow: '0 1px 4px rgba(0,0,0,.05)' }}>
            <div style={{ fontSize: 24, fontWeight: 800, color: s.color }}>{s.value}</div>
            <div style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Table */}
      <div style={{ background: 'white', borderRadius: 14, border: '1px solid #e2e8f0', overflow: 'hidden', boxShadow: '0 1px 4px rgba(0,0,0,.06)' }}>
        <div style={{ padding: '14px 20px', borderBottom: '1px solid #f1f5f9' }}>
          <h3 style={{ margin: 0, fontSize: 14, fontWeight: 700, color: '#1e293b' }}>
            👥 All Members ({members.length})
          </h3>
        </div>

        {loading ? (
          <div style={{ padding: 60, textAlign: 'center', color: '#94a3b8', fontSize: 14 }}>⏳ Loading...</div>
        ) : members.length === 0 ? (
          <div style={{ padding: 60, textAlign: 'center', color: '#94a3b8' }}>
            <div style={{ fontSize: 40, marginBottom: 12 }}>👤</div>
            <p style={{ fontSize: 14, margin: 0 }}>Koi member nahi hai — Add karein!</p>
          </div>
        ) : (
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  {['#', 'Member', 'Email', 'Slug', 'Role', 'Status', 'Joined', 'Actions'].map(h => (  // ✅ Slug column
                    <th key={h} style={{ padding: '12px 16px', textAlign: 'left', fontSize: 11, fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.05em', whiteSpace: 'nowrap' }}>
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {members.map((m, idx) => (
                  <tr key={m._id} style={{ borderBottom: '1px solid #f1f5f9' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                    onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                  >
                    <td style={{ padding: '14px 16px', color: '#94a3b8', fontWeight: 600 }}>{idx + 1}</td>

                    <td style={{ padding: '14px 16px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                        <div style={{ width: 36, height: 36, borderRadius: '50%', flexShrink: 0, background: getColor(m.name), display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, color: 'white' }}>
                          {getInitials(m.name)}
                        </div>
                        <span style={{ fontWeight: 600, color: '#1e293b' }}>{m.name}</span>
                      </div>
                    </td>

                    <td style={{ padding: '14px 16px', color: '#475569' }}>{m.email}</td>

                    {/* ✅ Slug column */}
                    <td style={{ padding: '14px 16px' }}>
                      <span style={{ padding: '3px 10px', background: '#f1f5f9', color: '#475569', borderRadius: 6, fontSize: 11, fontWeight: 600, fontFamily: 'monospace' }}>
                        {m.slug || '-'}
                      </span>
                    </td>

                    <td style={{ padding: '14px 16px' }}>
                      <span style={{ padding: '4px 10px', background: '#eff6ff', color: '#1e40af', border: '1px solid #bfdbfe', borderRadius: 20, fontSize: 11, fontWeight: 700, textTransform: 'capitalize' }}>
                        {m.roleName || '-'}
                      </span>
                    </td>

                    <td style={{ padding: '14px 16px' }}>
                      <button onClick={() => handleToggleStatus(m._id)}
                        style={{ padding: '4px 12px', fontSize: 11, fontWeight: 700, borderRadius: 20, cursor: 'pointer', background: m.isActive ? '#f0fdf4' : '#fef2f2', color: m.isActive ? '#16a34a' : '#dc2626', border: `1px solid ${m.isActive ? '#bbf7d0' : '#fecaca'}` }}>
                        {m.isActive ? '● Active' : '● Inactive'}
                      </button>
                    </td>

                    <td style={{ padding: '14px 16px', color: '#94a3b8', whiteSpace: 'nowrap' }}>
                      {new Date(m.createdAt).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
                    </td>

                    <td style={{ padding: '14px 16px' }}>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={() => openEditModal(m)}
                          style={{ padding: '6px 10px', background: '#eff6ff', color: '#1e40af', border: '1px solid #bfdbfe', borderRadius: 7, cursor: 'pointer', fontSize: 13 }}>
                          <IconEdit />
                        </button>
                        <button onClick={() => setDeleteConfirm(m._id)}
                          style={{ padding: '6px 10px', background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 7, cursor: 'pointer', fontSize: 13 }}>
                          <IconDelete />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}

export default AddManagementMember